import { ApolloProvider } from '@apollo/client';
import { RouterProvider } from 'react-router-dom';

import '@soteria/design-system-ve/style.css';
import { ThemeDebug } from './core/components/ThemeDebug';
import { LoggingErrorBoundary } from './core/logging/ErrorBoundary';
import { LoggerProvider } from './core/logging/LoggerProvider';
import { setupGlobalErrorHandlers, setupPerformanceMonitoring } from './core/logging/globalErrorHandler';
import { FeatureFlagProvider } from './core/providers/FeatureFlagProvider';
import { NotificationProvider } from './core/providers/NotificationProvider';
import { StyleProvider } from './core/providers/StyleProvider';
import { apolloClient } from './core/services/ApolloClient';
import { router } from './router';
import { Provider } from './store/Provider';

// Initialize global error handlers and performance monitoring
if (typeof window !== 'undefined') {
  setupGlobalErrorHandlers();
  setupPerformanceMonitoring();
}

// Main App component
export function App() {
  return (
    <LoggingErrorBoundary componentName="App">
      <Provider>
        <LoggerProvider>
          <ApolloProvider client={apolloClient}>
            {/* Use our custom StyleProvider which initializes theme from localStorage */}
            <StyleProvider>
              <FeatureFlagProvider>
                <NotificationProvider>
                  <RouterProvider router={router} />
                  <ThemeDebug />
                </NotificationProvider>
              </FeatureFlagProvider>
            </StyleProvider>
          </ApolloProvider>
        </LoggerProvider>
      </Provider>
    </LoggingErrorBoundary>
  );
}
